export default "__VITE_ASSET__5e881769__"